import React from "react";
import {observer} from "mobx-react";

import "./legend-list-item.scss";

import {Table, Image, Icon} from "semantic-ui-react";
import {LegendItemConfiguration, LegendItemType} from "../../../../../../../../config/legend-configuration";
import SimpleLineSymbolProperties = __esri.SimpleLineSymbolProperties;
import { SimpleLineSymbol } from "@arcgis/core/symbols";


interface LegendItemListProps {
    config: LegendItemConfiguration;
}

@observer
export class LegendListItem extends React.Component<LegendItemListProps, any> {

    constructor(props: LegendItemListProps) {
        super(props);
    }

    /**
     * Convert \n line breaks to <br/> html breaks
     *
     * @param text
     */
    static addLineBreaks(text: string):  React.ReactElement[] {
        return text.split("\n").map((txt, index) => (
            <React.Fragment key={`${txt}-${index}`}>
                {txt}
                <br/>
            </React.Fragment>
        )
        );
    }

    componentDidMount(): void {
    }

    componentWillUnmount(): void {
    }

    render(): React.ReactElement | null {
        let symbol;
        if (this.props.config.type === LegendItemType.Icon) {
            symbol = (
                <div className="geo-legend-list-item-icon">
                    {this.props.config.url &&
                        <Image src={this.props.config.url} size="mini"/>
                    }
                    {this.props.config.iconName &&
                        <Icon name={this.props.config.iconName} size="large"/>
                    }
                </div>
            );
        } else if (this.props.config.type === LegendItemType.Path) {
            // svg path
            symbol = this.svgPath();
        } else if (this.props.config.type === LegendItemType.Circle) {
            symbol = this.svgCircle();
        } else {
            symbol = (
                <div className={`geo-legend-list-item-patch ${this.props.config.type}`}
                    style={{backgroundColor: this.props.config.color}}>
                    &nbsp;
                </div>
            );
        }

        return (
            <Table.Row className="geo-legend-list-item" key={this.props.config.id}>
                <Table.Cell className={"geo-legend-class-symbol"} width={1}>
                    {symbol}
                </Table.Cell>
                {this.props.config.class &&
                <Table.Cell className={"geo-legend-class"} singleLine={true} width={2}>
                    {this.props.config.class}
                </Table.Cell>
                }
                <Table.Cell className={"geo-legend-class-description"}
                    singleLine={true}
                    width={this.props.config.class ? 2 : 4}
                    colSpan={this.props.config.class ? 1 : 2}>
                    {LegendListItem.addLineBreaks(this.props.config.description)}
                </Table.Cell>
            </Table.Row>
        );

    }

    private svgPath() {
        // svg path
        const transformation = this.props.config.angle ? `rotate(${this.props.config.angle})` : undefined;
        const outline = new SimpleLineSymbol(this.props.config.outline as SimpleLineSymbolProperties);
        return (
            <div className={`geo-legend-list-item-path ${this.props.config.type}`}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 28">
                    <g>
                        <path d={this.props.config.svgPath} fill={this.props.config.color}
                            transform={transformation}
                            stroke={outline.color.toCss()} strokeWidth={outline.width}
                            strokeLinecap={outline.cap}/>
                    </g>
                </svg>
            </div>
        );
    }

    private svgCircle() {
        // svg path
        const transformation = this.props.config.angle ? `rotate(${this.props.config.angle})` : undefined;
        const outline = new SimpleLineSymbol(this.props.config.outline as SimpleLineSymbolProperties);
        return (
            <div className={"geo-legend-list-item-path"}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 22">
                    <g>
                        <circle
                            r="5"
                            cy="12"
                            cx="16"
                            transform={transformation}
                            fill={this.props.config.color}
                            stroke={outline.color.toCss()}
                            strokeWidth={outline.width}
                            strokeLinecap={outline.cap}
                        />
                    </g>
                </svg>
            </div>
        );
    }
}
